<template>
  <div>
    <notifications />
    <template v-if="inital">
      <template v-if="user">
        <template v-if="business || root">
          <div :class="{ 'nav-open': $sidebar.showSidebar }">
            <template v-for="(card, key) in $route.query">
              <component
                :key="key"
                :is="key"
                :style="{
                  zIndex: priority[key] ? priority[key] : 10,
                }"
                v-if="items[key]"
                :id="card"
              />
            </template>
            <router-view />
          </div>
        </template>
        <template v-else>
          <businesses-change />
        </template>
      </template>
      <div v-else>
        <auth />
      </div>
    </template>
    <policy />
  </div>
</template>

<script>
import Auth from "@/pages/Auth";
import BusinessesChange from "@/pages/BusinessesChange";
import Policy from "@/components/Modals/Policy";

import "@/assets/sass/helper.scss";
import "@/assets/sass/theme.scss";

import { mapState } from "vuex";

export default {
  data: () => ({
    inital: false,
    audio: null,
    priority: {},
    isCard: false,
    bid: localStorage.getItem("bid"),
  }),
  components: {
    Auth,
    BusinessesChange,
    Policy,
  },
  computed: {
    ...mapState([
      "user",
      "business",
      "modalName",
      "items",
      "lastMessage",
      "root",
    ]),
  },
  methods: {},
  mounted() {
    this.$store.dispatch("setHost", process.env.HOST_URL);

    this.$loading(true);
    this.$http.get("system").then((response) => {
      this.$store.dispatch("setText", response.data.text);
      this.$store.dispatch("setCourse", response.data.courses);
      this.$store.dispatch("setLanguages", response.data.languages);
      this.$http
        .get("profile")
        .then((response) => {
          let data = response.data.data;
          this.$store.dispatch("setUser", data);
          this.$store.dispatch("setRoles", data.roles);
          this.$store.dispatch("setRoot", false);
          this.$store.dispatch("setLocations", data.locations);
          if (data.business) {
            localStorage.setItem("bid", data.business.id);
            this.$http.defaults.headers.common["bid"] = data.business.id;
            this.$store.dispatch("setRoot", false);
            this.$store.dispatch("setBusiness", data.business);
            this.$store.dispatch("setRoutes", data.business.routes);
          } else if (data.root) {
            this.$store.dispatch("setRoot", true);
            this.$store.dispatch("setBusiness", null);
            this.$store.dispatch("setRoutes", data.routes_root);
          }
          try {
            this.$socket.$subscribe(data["channel"], (msg) => {
              const data = {};
              data[msg.chat["chat"]["id"]] = {
                ...msg.message,
                userable: msg.chat,
              };
              setTimeout(() => {
                this.$store.dispatch("setMessage", data);
              }, 500);
            });
          } catch (error) {}
        })
        .catch((error) => {
          this.$store.dispatch("setUser", null);
          this.$store.dispatch("setRoot", false);
          this.$store.dispatch("setBusiness", null);
          localStorage.setItem("bid", "");
          this.$http.defaults.headers.common["bid"] = "";
        })
        .finally(() => {
          this.inital = true;
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    });
  },
  watch: {
    modalName(val) {
      if (val) {
        setTimeout(() => {
          this.$modal.show(val.model);
        }, 10);
      }
    },
    "$route.query": {
      handler: function (val) {
        let k = 1;
        let isOpened = false;
        for (var key in val) {
          if (this.items[key]) {
            isOpened = true;
          }
          k++;
          this.priority[key] = 3 + k;
        }
        if (isOpened === true) {
          document.documentElement.style.overflowY = "hidden";
        } else {
          document.documentElement.style.overflowY = "scroll";
        }
        this.isCard = isOpened;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
.notifications {
  z-index: 999999;
}
</style>

